export default "__VITE_ASSET__DAaIz4HD__"